// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"e46bb659","86":"86dc24a7","134":"b5c9b920","164":"833d13a6","246":"2aa7c497","282":"55481277","416":"0be7b56b","422":"48dda10d","453":"e12aa1b7","536":"d756d5b1","579":"db79c050","739":"d2550f60","857":"5fd3382b","901":"a76449b1"}[chunkId] + ".chunk.js";
};